import { FORMAT_HEADING_1_MENU_ITEM, FORMAT_HEADING_2_MENU_ITEM, FORMAT_HEADING_3_MENU_ITEM, FORMAT_HEADING_4_MENU_ITEM, FORMAT_HEADING_5_MENU_ITEM, FORMAT_HEADING_6_MENU_ITEM, FORMAT_NESTED_MENU_RANK, FORMAT_NESTED_MENU_RANK_REVISED, FORMAT_PARAGRAPH_MENU_ITEM, FORMAT_QUOTE_MENU_ITEM } from '@atlaskit/editor-common/block-menu';
import { fg } from '@atlaskit/platform-feature-flags';
import { createHeadingBlockMenuItem } from './HeadingBlockMenuItem';
import { createParagraphBlockMenuItem } from './ParagraphBlockMenuItem';
import { createQuoteBlockMenuItem } from './QuoteBlockMenuItem';
export var getBlockTypeComponents = function getBlockTypeComponents(api) {
  return [{
    type: 'block-menu-item',
    key: FORMAT_HEADING_1_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_HEADING_1_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_HEADING_1_MENU_ITEM.key]
    },
    component: createHeadingBlockMenuItem({
      level: 1,
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_HEADING_2_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_HEADING_2_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_HEADING_2_MENU_ITEM.key]
    },
    component: createHeadingBlockMenuItem({
      level: 2,
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_HEADING_3_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_HEADING_3_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_HEADING_3_MENU_ITEM.key]
    },
    component: createHeadingBlockMenuItem({
      level: 3,
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_HEADING_4_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_HEADING_4_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_HEADING_4_MENU_ITEM.key]
    },
    component: createHeadingBlockMenuItem({
      level: 4,
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_HEADING_5_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_HEADING_5_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_HEADING_5_MENU_ITEM.key]
    },
    component: createHeadingBlockMenuItem({
      level: 5,
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_HEADING_6_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_HEADING_6_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_HEADING_6_MENU_ITEM.key]
    },
    component: createHeadingBlockMenuItem({
      level: 6,
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_PARAGRAPH_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_PARAGRAPH_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_PARAGRAPH_MENU_ITEM.key]
    },
    component: createParagraphBlockMenuItem({
      api: api
    })
  }, {
    type: 'block-menu-item',
    key: FORMAT_QUOTE_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: 'nested-menu-format-section-primary',
      rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_QUOTE_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_QUOTE_MENU_ITEM.key]
    },
    component: createQuoteBlockMenuItem({
      api: api
    })
  }];
};